import './app-styles/app-styles.scss'

import React from 'react'

import Grid from './grid/grid'
import View from './view/view'

const DevApp = () => {
  return (
    <div className="app-container">
      <Grid />
      <View />
    </div>
  )
}

const ProdApp = () => {
  return (
    <div className="app-container">
      <View />
    </div>
  )
}

const app = process.env.NODE_ENV === 'production' ? ProdApp : DevApp

export default app



// WEBPACK FOOTER //
// ./src/app.js